export * from './types';

import { TurnstileCaptcha } from './TurnstileCaptcha';
import { CaptchaFC } from './types';

export const Captcha: CaptchaFC = TurnstileCaptcha;
